import React from 'react'
import { Helmet } from 'react-helmet'
import { useDispatch } from 'react-redux'

import { EuiPage, EuiPageBody, EuiPageHeader, EuiPageHeaderSection, EuiPanel, EuiTitle } from '@elastic/eui'

import { Account } from '../../api/interfaces'
import { hideAccountsFlyout, showSuccessToast, updateAccountState } from '../../app/appSlice'
import history from '../../services/HistoryService'
import { ClientsGrid } from './ClientsGrid'

export const ClientPickerPage = () => {
  const dispatch = useDispatch()

  const selectClient = (account: Account) => {
    dispatch(updateAccountState(account))
    dispatch(showSuccessToast(`Switch account to ${account.name}`))
    dispatch(hideAccountsFlyout())
    history.push('/masterCampaigns')
  }

  const clickClientName = (account: Account) => {
    dispatch(updateAccountState(account))
    dispatch(showSuccessToast(`Switch account to ${account.name}`))
    dispatch(hideAccountsFlyout())
    history.push('/client-details')
  }

  return (
    <EuiPage className='euiPage--platform'>
      <EuiPageBody>
        <Helmet>
          <h1>Clients</h1>
        </Helmet>
        <EuiPageHeader>
          <EuiPageHeaderSection>
            <EuiTitle>
              <h1>Clients</h1>
            </EuiTitle>
          </EuiPageHeaderSection>
        </EuiPageHeader>
        <EuiPanel grow={false} className='eui-xScroll'>
          <ClientsGrid
            onClickClientName={clickClientName}
            clientAction={selectClient}
            onCreateClient={() => {
              history.push('/create-client')
            }}
          />
        </EuiPanel>
      </EuiPageBody>
    </EuiPage>
  )
}
